import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "echarts-chart-zoom-toolbar" }
const _hoisted_2 = ["aria-label", "onClick"]
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button) => {
      return (_openBlock(), _createElementBlock("button", {
        key: button.id,
        type: "button",
        class: _normalizeClass(["echarts-chart-zoom-toolbar__button", { 'echarts-chart-zoom-toolbar__button--active': button.active }]),
        "aria-label": button.title,
        onClick: _withModifiers(button.onClick, ["stop"])
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _createElementVNode("path", {
            d: button.path
          }, null, 8, _hoisted_4)
        ]))
      ], 10, _hoisted_2))
    }), 128))
  ]))
}